module.exports = __webpack_public_path__ + "img/ap2020-result-logo-cn.21271e3.png";